import React from 'react';
//children
import NavigationList from '../../../../common/NavigationList/';

const PoolList = (props) => {
  const { pageJson, selectedSowProduct } = props;
  const list = (selectedSowProduct.notionalPooling && selectedSowProduct.notionalPooling.poolingStructure &&
    selectedSowProduct.notionalPooling.poolingStructure.pools) || []

  return (
    <div className="gdoc-np-pool-list-container">
      <NavigationList
        history={props.history}
        listtype="caseBodyProductRequests"
        pageReferer="notionalPoolingList"
        cases={props.cases}
        productDetailsdata={list}
        deletePool={props.deletePool}
        redirectToForm={props.editPoolEvent}
        pageJson={pageJson}
        lang={props.lang}
      />

    </div>
  );
}

export default PoolList;



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/NotionalPoolSummary/GlsNotionalPoolingStrucutre/PoolList.js